var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2276E3",
    d: "M16.255 26.177a1.274 1.274 0 00-.517 2.495 10.948 10.948 0 009.193-19.158A10.95 10.95 0 007.829 22.127c.025.058.977-.597 1.533-1.057.481-.399.579-.604.568-.64a8.416 8.416 0 116.326 5.753l-.001-.006z"
  }))));
}
export default SvgReload;